export class DistributorAuction {

  constructor() { }

  distributerLogistic: string;
  distributerParticipant: string;
  distributerParticipant2: string;
  distributerParticipant3: string;
  distributerParticipantSAI1: string;
  distributerParticipantSAI2: string;
  distributerWinner: string;
  distributerParticipantName: string;
  distributerParticipant2Name: string;
  distributerParticipant3Name: string;
  distributerParticipantSAI1Name: string;
  distributerParticipantSAI2Name: string;
  distributerWinnerName: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/distributor-auction.ts